import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Currency } from '../../../models/Currency';
import { CompanyService } from '../../../services/company.service';

@Component({
    selector: 'app-company-settings-currency',
    templateUrl: './company-settings-currency.component.html',
    styleUrls: ['./company-settings-currency.component.css']
})
export class CompanySettingsCurrencyComponent implements OnInit {
    public companySettings: any;
    public companyCurrencySettingEditForm: UntypedFormGroup;
    public submitted = false;
    public preview = '';
    public currencies: Currency[];
    public canRender$: Observable<boolean>;

    constructor(
        private _companyService: CompanyService,
        private _fb: UntypedFormBuilder,
        private _ts: TranslateService,
    ) { }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.companyCurrencySettingEditForm.controls;
    }

    public ngOnInit(): void {
        this.companyCurrencySettingEditForm = this._fb.group({
            'company.currency.code': ['', Validators.required],
        });
        this.loadCurrencySettings();
    }

    public loadCurrencySettings() {
        this.canRender$ = combineLatest([
            this._companyService.getCurrencies(),
            this._companyService.getCompanyCurrencySetting()
        ])
            .pipe(
                tap(([currencies, companySettings]) => {
                    this.currencies = currencies;
                    this.companySettings = companySettings;

                    this.companyCurrencySettingEditForm.patchValue({
                        'company.currency.code': companySettings.currency_settings?.code ?? 'CZK',
                    });
                    const presetCurrency = currencies.find(curr => curr.code === (companySettings.currency_settings?.code ?? 'CZK'));

                    this.updatePreview(presetCurrency);
                }),
                map(() => true)
            );
    }

    public onSubmit(): void {
        this.submitted = true;
        if (!this.companyCurrencySettingEditForm.valid) {
            return;
        }
        const value = this.companyCurrencySettingEditForm.value;
        value.settings_type = 'currency';
        this._companyService.saveCompanySetting(this.companyCurrencySettingEditForm.value).then(() => window.location.reload());
    }

    public updatePreview(event: Currency) {
        this.preview = event.example_formatted;
    }
}
